import './uitgelichte-faciliteiten.scss'


// Lightweight slider port of the legacy UIkit 2 data-uk-slider behaviour.
// Re-uses the existing markup (uk-slider-container / ul.uk-slider /
// [data-uk-slider-item="previous|next"]) so the dumped legacy CSS keeps
// working. Moves the track in whole-slide steps; supports pointer swipe.

const SWIPE_THRESHOLD_RATIO = 0.2;

const initFacilitySlider = ( root ) => {
	const container = root.querySelector( '.uk-slider-container' );
	const track = root.querySelector( '.uk-slider' );
	const prev = root.querySelector( '[data-uk-slider-item="previous"]' );
	const next = root.querySelector( '[data-uk-slider-item="next"]' );

	if ( ! container || ! track ) {
		return;
	}

	const items = Array.from( track.children );
	if ( items.length === 0 ) {
		return;
	}

	let index = 0;
	let pointerStartX = null;
	let pointerStartOffset = 0;
	let activePointerId = null;

	const slideWidth = () => items[ 0 ].getBoundingClientRect().width;

	const visibleCount = () => {
		const width = slideWidth();
		if ( width <= 0 ) {
			return 1;
		}
		return Math.max( 1, Math.round( container.clientWidth / width ) );
	};

	const maxIndex = () => Math.max( 0, items.length - visibleCount() );

	const clamp = ( value ) => Math.min( Math.max( value, 0 ), maxIndex() );

	const updateNav = () => {
		const atStart = index <= 0;
		const atEnd = index >= maxIndex();
		if ( prev ) {
			prev.classList.toggle( 'uk-invisible', atStart );
			prev.setAttribute( 'aria-disabled', atStart ? 'true' : 'false' );
		}
		if ( next ) {
			next.classList.toggle( 'uk-invisible', atEnd );
			next.setAttribute( 'aria-disabled', atEnd ? 'true' : 'false' );
		}
	};

	const apply = ( animate = true ) => {
		index = clamp( index );
		track.style.transition = animate ? '' : 'none';
		track.style.transform = `translate3d(${ -index * slideWidth() }px, 0, 0)`;
		updateNav();
	};

	const go = ( delta ) => {
		index = clamp( index + delta );
		apply( true );
	};

	if ( prev ) {
		prev.addEventListener( 'click', ( event ) => {
			event.preventDefault();
			go( -1 );
		} );
	}

	if ( next ) {
		next.addEventListener( 'click', ( event ) => {
			event.preventDefault();
			go( 1 );
		} );
	}

	// Reposition on resize / column count change.
	const ro = new ResizeObserver( () => apply( false ) );
	ro.observe( container );

	// Pointer swipe (mouse + touch + pen).
	container.addEventListener( 'pointerdown', ( event ) => {
		if ( event.pointerType === 'mouse' && event.button !== 0 ) {
			return;
		}
		pointerStartX = event.clientX;
		pointerStartOffset = -index * slideWidth();
		activePointerId = event.pointerId;
		track.style.transition = 'none';
		container.setPointerCapture?.( event.pointerId );
	} );

	container.addEventListener( 'pointermove', ( event ) => {
		if ( pointerStartX === null || event.pointerId !== activePointerId ) {
			return;
		}
		const dx = event.clientX - pointerStartX;
		track.style.transform = `translate3d(${ pointerStartOffset + dx }px, 0, 0)`;
	} );

	const endPointer = ( event ) => {
		if ( pointerStartX === null || event.pointerId !== activePointerId ) {
			return;
		}
		const dx = event.clientX - pointerStartX;
		pointerStartX = null;
		activePointerId = null;
		const threshold = slideWidth() * SWIPE_THRESHOLD_RATIO;
		if ( dx < -threshold ) {
			index += 1;
		} else if ( dx > threshold ) {
			index -= 1;
		}
		apply( true );
	};

	container.addEventListener( 'pointerup', endPointer );
	container.addEventListener( 'pointercancel', endPointer );

	// Prevent native image drag from stealing the pointer on desktop.
	track.querySelectorAll( 'a, img' ).forEach( ( el ) => {
		el.addEventListener( 'dragstart', ( event ) => event.preventDefault() );
	} );

	apply( false );
};

document
	.querySelectorAll( '.js-facilitySlider' )
	.forEach( initFacilitySlider );
